// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_SendMessagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for send_messages() /mensagens_programadas/send_messages
 * Returns the result of scheduling messages from templates.
 */
import type { MensagensProgramadas_SendMessageResultRow } from './MensagensProgramadas_SendMessageResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadas_SendMessagesResponseDados {
success: boolean
results: MensagensProgramadas_SendMessageResultRow[]
success_count: number
error_count: number
}

export type MensagensProgramadas_SendMessagesResponse = ApiResponse<MensagensProgramadas_SendMessagesResponseDados>;

registerResponseContract('MensagensProgramadas_SendMessagesResponse', {
  success:       { type: 'boolean', required: true },
  results: {
    type: 'array',
    required: true,
    items: {
      success:     { type: 'boolean', required: true },
      cliente_id:  { type: 'number',  required: true },
      mensagem_id: { type: 'number',  required: false },
      message:     { type: 'string',  required: false },
      erro:        { type: 'string',  required: false },
    },
  },
  success_count: { type: 'number',  required: true },
  error_count:   { type: 'number',  required: true },
})
